export function setItemToStorage (itemName, itemData) {
  // console.log('setItemToStorage', itemName, itemData);
  try {
    let serialized = JSON.stringify(itemData);
    return localStorage.setItem(itemName, serialized);
  } catch (e) {
    return undefined;
  }
}

export function getItemFromStorage (itemName) {
  // console.log('getItemFromStorage', itemName);
  try {
    let serialized = localStorage.getItem(itemName);
    if (serialized === null) {
      return undefined;
    }
    return !serialized ? serialized : JSON.parse(serialized);
  } catch (e) {
    return undefined;
  }
}

export function removeItemFromStorage (itemName) {
  // console.log('removeItemFromStorage', itemName);
  try {
    return localStorage.removeItem(itemName);
  } catch (e) {
    return undefined;
  }
}
